const API_URL = process.env.GATSBY_MMC_API_URL;
const getJwt = () => localStorage.getItem('jwt');
const getHeaders = () => ({ Authorization: `Bearer ${getJwt()}` });

async function get(url) {
    const headers = getHeaders();

    try {
        const response = await fetch(`${API_URL}/${url}`, { headers });
        if (response.status !== 200) return null;

        return await response.json();
    } catch (error) {
        return null;
    }
}

export const me = () => get("users/me");
